export default "__VITE_ASSET__uTd1RD3o__"